"use client";

export function useGTMEvent() {
    const pushEvent = (eventName: string, eventData: Record<string, unknown> = {}) => {
        if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
                event: eventName,
                ...eventData,
            });
        } else {
            console.warn("[GTM] dataLayer is not available.");
        }
    };

    return { pushEvent };
}
